import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import { SCREENS } from '../../constants/tracking/Screens';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
const productsConfig = {
  PROFESSIONAL: {
    apiName: Products.CORE_SEATS_PROFESSIONAL,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.smartCrm.professionalCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.smartCrm.professional.lowerTierPlus"
    }),
    skipInterstitial: true
  },
  ENTERPRISE: {
    apiName: Products.CORE_SEATS_ENTERPRISE,
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.smartCrm.enterpriseCard.description"
    }),
    lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.smartCrm.enterprise.lowerTierPlus"
    }),
    skipInterstitial: true
  }
};
export const SmartCrmMerchCards = () => {
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig,
    screen: SCREENS.SMART_CRM
  });
};